<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions /></div>
          </div>
        </section>
      </b-card>

      <b-row>
        <b-col lg="7">
          <b-card class="notifications-manual-form">
            <b-row class="notifications-manual-form__content">
              <b-col lg="4" md="6">
                <b-form-group label="Medio">
                  <b-form-select size="sm" v-model="crud.form.method" :options="arr.select.methods"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col lg="4" md="6" v-if="crud.form.method != 'internal' && crud.form.method != 'sms'">
                <b-form-group label="Tipo de Usuario">
                  <b-form-select size="sm" v-model="crud.form.type" :options="filteredTypes"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" v-if="crud.form.method == 'sms'">
                <b-alert show variant="danger" class="notifications-manual-alert">
                  <AppIcon name="warning" class="mr-1" />
                  <b>Sin soporte.</b> El canal SMS ya no está soportado y no puede utilizarse para el envío manual.
                </b-alert>
              </b-col>
              <b-col cols="12" v-if="crud.form.method != 'sms'">
                <section class="notifications-manual-section">
                <div class="notifications-manual-section-title"><AppIcon name="person" /> Destinatario</div>
                <FindObject type="staff"
                            @select-object="loadStaff($event)"
                            :valueID="crud.form.staff_id"
                            render="search"
                            v-if="crud.form.method == 'internal' || ((crud.form.method == 'email' || crud.form.method == 'whatsapp') && crud.form.type == 'staff')"
                            :key="'notifications_staff_internal_'+crud.form.staff_id"/>

                <FindObject type="staff-subscription-push"
                            @select-object="loadStaff($event)"
                            :valueID="crud.form.staff_id"
                            render="search"
                            v-if="crud.form.method == 'push' && crud.form.type == 'staff'"
                            :key="'notifications_staff_'+crud.form.staff_id"/>

                <FindObject type="customers-subscription-push"
                            @select-object="loadCustomers($event)"
                            :valueID="crud.form.customer_id"
                            render="search"
                            v-if="crud.form.method == 'push' && crud.form.type == 'customer'"
                            :key="'notifications_customer_'+crud.form.customer_id"/>

                <FindObject type="suppliers-subscription-push"
                            @select-object="loadSuppliers($event)"
                            :valueID="crud.form.supplier_id"
                            render="search"
                            v-if="crud.form.method == 'push' && crud.form.type == 'supplier'"
                            :key="'notifications_supplier_'+crud.form.supplier_id"/>

                <FindObject type="customers"
                            @select-object="loadCustomers($event)"
                            :valueID="crud.form.customer_id"
                            render="search"
                            v-if="(crud.form.method == 'email' || crud.form.method == 'whatsapp') && crud.form.type == 'customer'"
                            :key="'notifications_customer_email_'+crud.form.customer_id"/>

                <FindObject type="suppliers"
                            @select-object="loadSuppliers($event)"
                            :valueID="crud.form.supplier_id"
                            render="search"
                            v-if="(crud.form.method == 'email' || crud.form.method == 'whatsapp') && crud.form.type == 'supplier'"
                            :key="'notifications_supplier_email_'+crud.form.supplier_id"/>

                <b-form-group label="Email"
                              v-if="crud.form.method == 'email' && crud.form.type == 'external'">
                  <b-form-input type="email" size="sm" v-model="crud.form.email" placeholder="email@dominio.com"></b-form-input>
                </b-form-group>

                <b-form-group label="Teléfono"
                              description="Cod país [sin el signo] + cod área [sin el 0] + nro cel [sin el 15]. Con o sin el 9 de móvil, se ajusta automáticamente."
                              v-if="crud.form.method == 'whatsapp' && crud.form.type == 'external'">
                  <b-form-input type="number" size="sm" v-model="crud.form.phone" placeholder="543416908870"></b-form-input>
                </b-form-group>
                </section>
              </b-col>
              <template v-if="crud.form.method != 'sms'">
                <b-col cols="12">
                  <section class="notifications-manual-section">
                    <div class="notifications-manual-section-title"><AppIcon name="chat" /> Contenido</div>
                    <b-row>
                <b-col lg="6" md="6" v-if="crud.form.method == 'whatsapp'">
                  <b-form-group label="Instancia de Whatsapp">
                    <b-form-select size="sm" v-model="crud.form.notifications_whatsapp_id" :options="whatsappInstanceOptions"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col lg="6" md="6" v-if="crud.form.method == 'whatsapp'">
                  <b-form-group label="Plantilla" description="'Texto libre' solo funciona si el destinatario te escribió en las últimas 24hs">
                    <b-form-select size="sm" v-model="crud.form.whatsapp_template_id" :options="whatsappTemplateOptions"></b-form-select>
                  </b-form-group>
                </b-col>

                <b-col lg="12" v-if="crud.form.method != 'whatsapp'">
                  <b-form-group label="Título">
                    <b-form-input size="sm" v-model="crud.form.title" placeholder="Título"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col lg="12" v-if="crud.form.method != 'whatsapp' || !crud.form.whatsapp_template_id">
                  <b-form-group label="Mensaje">
                    <b-textarea size="sm" v-model="crud.form.message" placeholder="Mensaje" rows="5"></b-textarea>
                  </b-form-group>
                </b-col>
                <b-col lg="12" v-if="crud.form.method == 'whatsapp' && crud.form.whatsapp_template_id">
                  <b-card class="notifications-manual-template mb-3">
                    <div class="small text-muted mb-2">{{ selectedWhatsappTemplate ? selectedWhatsappTemplate.body : '' }}</div>
                    <b-form-group v-for="(param, index) in crud.form.whatsapp_template_params"
                                  :key="'whatsapp_template_param_'+index"
                                  :label="'Parámetro {{' + (index + 1) + '}}'"
                                  class="mb-2">
                      <b-form-input size="sm" v-model="crud.form.whatsapp_template_params[index]"></b-form-input>
                    </b-form-group>
                  </b-card>
                </b-col>

                <b-col lg="12" v-if="crud.form.method != 'whatsapp'">
                  <b-form-group label="URL" description="URL de redireccionamiento en el click">
                    <b-form-input size="sm" v-model="crud.form.url" placeholder="URL"></b-form-input>
                </b-form-group>
                </b-col>
                <b-col cols="12">
                  <div class="notifications-manual-actions">
                    <b-button variant="outline-secondary" size="sm" @click="clean()">Limpiar</b-button>
                    <b-button variant="dark" size="sm" @click="send()"><AppIcon name="send" class="mr-1" />Enviar notificación</b-button>
                  </div>
                </b-col>
                    </b-row>
                  </section>
                </b-col>
              </template>
            </b-row>
          </b-card>
        </b-col>
        <b-col lg="5">
          <b-card no-body class="notifications-manual-result-card">
            <div class="notifications-manual-result-card__heading">
              <AppIcon name="terminal" />
              <div><h6>Resultado</h6><span>Respuesta del último envío</span></div>
            </div>
            <div class="notifications-manual-result-card__body">
              <prism-editor v-if="crud.form.result" v-model="crud.form.result" language="json" class="notifications-send-manual-result" :readonly="true"></prism-editor>
              <EmptyState v-else
                          icon="terminal"
                          title="Sin resultado todavía"
                          description="La respuesta del servicio aparecerá acá después de enviar una notificación." />
            </div>
          </b-card>
        </b-col>
      </b-row>

      <b-card body-class="py-2">
        <div class="list-view-footer">
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <AppIcon name="back" /> Volver
            </b-button>
        </div>
      </b-card>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Funciones from '@/handler/funciones'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  import FindObject from '@/components/inc/find/findObject'
  import PrismEditor from 'vue-prism-editor'
  import "prismjs";
  import "prismjs/themes/prism.css";
  import 'prismjs/components/prism-json';

  export default {
    components: {          
      FindObject,
      PrismEditor,
      TabHeaderActions,
    },    
    data: () => {
      return {      
        access: {
          module_id: Modules.NOTIFICACIONES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'manualSend',
          elements: {}
        }, 
        crud: {
          form: {
            method: 'email',
            source: 'SYSTEM',
            type: 'external',
            title: '',
            message: '',
            url: '',
            staff: null,
            staff_id: 0,
            customer: null,
            customer_id: 0,
            supplier: null,
            supplier_id: 0,
            email: '',
            phone: '',
            notifications_whatsapp_id: 0,
            whatsapp_template_id: '',
            whatsapp_template_params: [],
            result: ''
          }
        },
        whatsappInstances: [],
        whatsappTemplates: [],
        arr: {
          select: {
            methods: [
              { value: 'email', text: 'EMAIL', disabled: false },
              { value: 'push', text: 'PUSH', disabled: false },
              { value: 'internal', text: 'INTERNA', disabled: false },
              { value: 'whatsapp', text: 'WHATSAPP', disabled: false },
              { value: 'sms', text: 'SMS', disabled: false },
            ],
            types: [
              { value: 'staff', text: 'STAFF' },
              { value: 'customer', text: 'CLIENTES' },
              { value: 'supplier', text: 'PROVEEDORES' },
              { value: 'external', text: 'EXTERNO' },
            ],
          }
        }
      }
    },
    computed: {
      filteredTypes() {
        if(this.crud.form.method == 'email' || this.crud.form.method == 'whatsapp') {
          return this.arr.select.types
        }
        return this.arr.select.types.filter((item) => item.value != 'external')
      },
      whatsappInstanceOptions() {
        return this.whatsappInstances.map((item) => ({ value: item.id, text: item.name }))
      },
      whatsappTemplateOptions() {
        var options = [{ value: '', text: 'Texto libre' }]
        this.whatsappTemplates.forEach((template) => {
          options.push({ value: template.id, text: template.name + ' (' + template.status + ')' })
        })
        return options
      },
      selectedWhatsappTemplate() {
        var id = this.crud.form.whatsapp_template_id
        return this.whatsappTemplates.find((template) => template.id == id) || null
      },
      whatsappTemplateVariablesCount() {
        var template = this.selectedWhatsappTemplate
        if(!template || !template.body) return 0
        var matches = template.body.match(/\{\{\d+\}\}/g)
        return matches ? matches.length : 0
      }
    },
    watch: {
      'crud.form.method'(value) {
        if(!this.crud.form.type || (value != 'email' && value != 'whatsapp' && this.crud.form.type == 'external')) {
          this.crud.form.type = 'staff'
        }
        this.resetRecipients()
      },
      'crud.form.type'() {
        this.resetRecipients()
      },
      'crud.form.whatsapp_template_id'() {
        this.crud.form.whatsapp_template_params = new Array(this.whatsappTemplateVariablesCount).fill('')
      }
    },
    mounted () {
      this.loadWhatsappInstances()
      this.loadWhatsappTemplates()
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    methods: {
      loadWhatsappInstances() {
        serviceAPI.obtenerWhatsapp()
          .then((response) => {
            this.whatsappInstances = response.data
            if(!this.crud.form.notifications_whatsapp_id && this.whatsappInstances.length) {
              this.crud.form.notifications_whatsapp_id = this.whatsappInstances[0].id
            }
          })
          .catch(error => {
            this.$awn.alert(Error.showError(error))
          })
      },
      loadWhatsappTemplates() {
        serviceAPI.listWhatsappTemplates()
          .then((response) => {
            this.whatsappTemplates = response.data
          })
          .catch(error => {
            this.$awn.alert(Error.showError(error))
          })
      },
      loadStaff(object){
        if(object){
          this.crud.form.staff = object
          this.crud.form.staff_id = object.id        

          this.crud.form.customer = null
          this.crud.form.customer_id = 0
          this.crud.form.supplier = null
          this.crud.form.supplier_id = 0                              
        } else {
          this.crud.form.staff = null
          this.crud.form.staff_id = 0
        }
      },
      loadCustomers(object){
        if(object){
          this.crud.form.customer = object
          this.crud.form.customer_id = object.id        

          this.crud.form.staff = null
          this.crud.form.staff_id = 0
          this.crud.form.supplier = null
          this.crud.form.supplier_id = 0                              
        } else {
          this.crud.form.customer = null
          this.crud.form.customer_id = 0
        }        
      },
      loadSuppliers(object){
        if(object){
          this.crud.form.supplier = object
          this.crud.form.supplier_id = object.id        

          this.crud.form.staff = null
          this.crud.form.staff_id = 0
          this.crud.form.customer = null
          this.crud.form.customer_id = 0                              
        } else {
          this.crud.form.supplier = null
          this.crud.form.supplier_id = 0
        }
      },

      resetRecipients() {
        this.crud.form.staff = null
        this.crud.form.staff_id = 0
        this.crud.form.customer = null
        this.crud.form.customer_id = 0
        this.crud.form.supplier = null
        this.crud.form.supplier_id = 0
        this.crud.form.email = ''
        this.crud.form.phone = ''
      },

      send() {
        if(this.crud.form.method == 'sms') {
          this.$awn.alert("El canal SMS ya no está soportado.");
          return false
        }

        if(this.crud.form.method == 'internal') {
          if(!this.crud.form.staff_id) {
            this.$awn.alert("Debes seleccionar un STAFF");
            return false
          }
        } else {
          if(this.crud.form.type=='staff' && !this.crud.form.staff_id) {
            this.$awn.alert("Debes seleccionar un STAFF");
            return false
          }
          if(this.crud.form.type=='customer' && !this.crud.form.customer_id) {
            this.$awn.alert("Debes seleccionar un CLIENTE");
            return false
          }
          if(this.crud.form.type=='supplier' && !this.crud.form.supplier_id) {
            this.$awn.alert("Debes seleccionar un PROVEEDOR");
            return false
          }
          if(this.crud.form.method == 'whatsapp' && ['staff', 'customer', 'supplier'].includes(this.crud.form.type)) {
            var recipient = this.crud.form.staff || this.crud.form.customer || this.crud.form.supplier
            if(!Funciones.validarTelefonoWhatsapp(recipient && recipient.phone)) {
              this.$awn.alert("El teléfono cargado para este destinatario no es válido para Whatsapp. Corregilo desde su ficha antes de enviar.");
              return false
            }
          }
          if(this.crud.form.type=='external' && this.crud.form.method == 'email') {
            if(!this.crud.form.email) {
              this.$awn.alert("Debes ingresar un EMAIL");
              return false
            }
            if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.crud.form.email)) {
              this.$awn.alert("Debes ingresar un EMAIL válido");
              return false
            }
          }
          if(this.crud.form.type=='external' && this.crud.form.method == 'whatsapp') {
            if(!Funciones.validarTelefonoWhatsapp(this.crud.form.phone)) {
              this.$awn.alert("Debes ingresar un TELÉFONO válido (con o sin el 9 de móvil)");
              return false
            }
          }
        }

        if(this.crud.form.method == 'whatsapp') {
          if(!this.crud.form.notifications_whatsapp_id) {
            this.$awn.alert("Debes seleccionar una instancia de Whatsapp");
            return false
          }
          if(this.crud.form.whatsapp_template_id) {
            var faltaParametro = this.crud.form.whatsapp_template_params.some((param) => !param)
            if(faltaParametro) {
              this.$awn.alert("Completá todos los parámetros de la plantilla");
              return false
            }
          } else if(!this.crud.form.message) {
            this.$awn.alert("Debes ingresar un mensaje o elegir una plantilla");
            return false
          }
        }

        this.confirmDialog('¿Confirmar el envío de la notificación?', {
          title: 'Enviar notificación',
          icon: 'send',
          okTitle: 'ENVIAR',
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = this.crud.form.method == 'internal'
              ? serviceAPI.manualSendInternal(this.crud.form)
              : serviceAPI.manualSend(this.crud.form);

            result.then((response) => { 
              loader.hide()              

              this.crud.form.result = JSON.stringify(response.data, null, 4)
              
              this.$awn.success("Notificación Enviada");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })            
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })            
      },
      clean() {
        this.crud.form.method = 'internal'
        this.crud.form.source = 'SYSTEM'
        this.crud.form.type = 'staff'
        this.crud.form.title = ''
        this.crud.form.message = ''
        this.crud.form.icon = ''
        this.crud.form.url = ''   
        this.crud.form.staff = null
        this.crud.form.staff_id = 0
        this.crud.form.customer = null
        this.crud.form.customer_id = 0
        this.crud.form.supplier = null
        this.crud.form.supplier_id = 0
        this.crud.form.email = ''
        this.crud.form.phone = ''
        this.crud.form.whatsapp_template_id = ''
        this.crud.form.whatsapp_template_params = []
        this.crud.form.result = ''
      },
      confirmDialog(message, options) {
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: options.icon || 'help' } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: options.okTitle,
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerClass: 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      }
    }
  }
</script>
<style>
.notifications-manual-result-card__heading {
  display: flex;
  align-items: center;
  gap: 10px;
}
.notifications-manual-result-card__heading h6 {
  margin: 0;
  color: var(--app-color-text);
  font-weight: var(--app-font-semibold);
}
.notifications-manual-result-card__heading span {
  margin: 2px 0 0;
  color: var(--app-color-text-muted);
  font-size: var(--app-text-sm);
}
.notifications-manual-result-card__heading > .app-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: var(--app-color-primary-soft);
  color: var(--app-color-primary);
}
.notifications-manual-form__content {
  width: calc(100% + 30px);
  max-width: none;
}
.notifications-manual-form .form-group {
  margin-bottom: 14px;
}
.notifications-manual-form .form-group > label,
.notifications-manual-form .form-group legend {
  margin-bottom: 5px;
  color: var(--app-color-text-secondary);
  font-size: var(--app-text-xs);
  font-weight: var(--app-font-semibold);
  letter-spacing: .02em;
  text-transform: uppercase;
}
.notifications-manual-form .form-text {
  margin-top: 4px;
  color: var(--app-color-text-muted);
  font-size: var(--app-text-xs);
}
.notifications-manual-section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--app-color-border);
  color: var(--app-color-text-secondary);
  font-size: var(--app-text-xs);
  font-weight: var(--app-font-semibold);
  letter-spacing: .03em;
  text-transform: uppercase;
}
.notifications-manual-section-title .app-icon { color: var(--app-color-text-muted); }
.notifications-manual-section {
  margin: 8px 0;
  padding: 14px 16px 4px;
  border: 1px solid var(--app-color-border);
  border-radius: 10px;
}
.notifications-manual-alert { display: flex; align-items: center; }
.notifications-manual-template {
  border-color: var(--app-color-border);
  background: var(--app-color-surface-subtle);
}
.notifications-manual-actions {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;
  padding-top: 16px;
  border-top: 1px solid var(--app-color-border);
}
.notifications-manual-result-card {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.notifications-manual-result-card__heading {
  padding: 14px 16px;
  border-bottom: 1px solid var(--app-color-border);
  background: var(--app-color-surface-subtle);
}
.notifications-manual-result-card__body {
  display: flex;
  flex: 1 1 auto;
  align-items: stretch;
  min-height: 0;
  padding: 12px;
  overflow: hidden;
}
.notifications-manual-result-card__body .app-empty-state {
  flex: 1 1 auto;
  width: 100%;
}
.notifications-send-manual-result {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  min-height: 400px;
}
.notifications-send-manual-result pre,
.notifications-send-manual-result textarea {
  width: 100% !important;
  height: 100% !important;
  margin: 0;
}
.notifications-send-manual-result .prism-editor__code {
  flex: 1 1 auto;
  min-width: 100%;
}
@media (max-width: 991.98px) {
  .notifications-manual-result-card { margin-top: 16px; }
}
@media (max-width: 575.98px) {
  .notifications-manual-actions { align-items: stretch; flex-direction: column-reverse; }
  .notifications-manual-actions .btn { width: 100%; }
}
</style>
